import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import {Header, Titulo} from '../elementos/Header'
import BtnRegresar from '../elementos/BtnRegresar'
import FormularioUbicacion from './FormularioUbicacion'
import favicon from '../imagenes/logoutm.png'

const RegistroUbicacion = () => {
    return (
        <>
            <HelmetProvider>
                <div>
                    <Helmet>
                        <link rel="shortcut icon" href={favicon} type="image/x-con"/>
                        <title>Registro de Ubicación</title>
                    </Helmet>
                </div>
            </HelmetProvider>

            <Header>
                    <Titulo>Registro de Ubicación</Titulo>
                    <BtnRegresar ruta="/ubicacion"/>
            </Header>

            <FormularioUbicacion />
        </>
    );
}
 
export default RegistroUbicacion;